"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.brandUpdate = exports.brandSuccess = exports.brandSoftDeletedList = exports.brandSoftDeleteRestore = exports.brandSoftDelete = exports.brandReset = exports.brandRemove = exports.brandListPbSite = exports.brandListPbReport = exports.brandList = exports.brandFetch = exports.brandError = exports.brandDelete = exports.brandContentList = exports.brandBulkSoftDelete = exports.brandBulkRestore = exports.brandBulkHardDelete = exports.brandApply = exports.brandAllList = exports.brandAdminList = exports.brandAdd = exports.brandAccessList = exports.brandAccess = exports.assetFolderViewTempDataSet = void 0;
var _brand = require("./brand.constant");
// @flow

// common success
var brandSuccess = function brandSuccess(actionType, data) {
  return {
    type: _brand.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.brandSuccess = brandSuccess;
var brandError = function brandError(actionType, error) {
  return {
    type: _brand.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.brandError = brandError;
var brandFetch = function brandFetch(data) {
  return {
    type: _brand.actionTypes.FETCH,
    payload: data
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get access of data.
 */
exports.brandFetch = brandFetch;
var brandAccess = function brandAccess(data) {
  return {
    type: _brand.actionTypes.ACCESS,
    payload: data
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get list of data.
 */
exports.brandAccess = brandAccess;
var brandList = function brandList(data) {
  return {
    type: _brand.actionTypes.LIST,
    payload: data
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get list of data.
 */
exports.brandList = brandList;
var brandAllList = function brandAllList(data) {
  return {
    type: _brand.actionTypes.ALL_LIST,
    payload: data
  };
};

/**
 * list pb site
 * @param payload
 * @returns api response
 * @description this function used to get list of data.
 */
exports.brandAllList = brandAllList;
var brandListPbSite = function brandListPbSite(data) {
  return {
    type: _brand.actionTypes.LIST_PB_SITE,
    payload: data
  };
};

/**
 * list pb report
 * @param payload
 * @returns api response
 * @description this function used to get list of data.
 */
exports.brandListPbSite = brandListPbSite;
var brandListPbReport = function brandListPbReport(data) {
  return {
    type: _brand.actionTypes.LIST_PB_REPORT,
    payload: data
  };
};

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to dalete data.
 */
exports.brandListPbReport = brandListPbReport;
var brandDelete = function brandDelete(data) {
  return {
    type: _brand.actionTypes.DELETE,
    payload: data
  };
};

/**
 * add
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
exports.brandDelete = brandDelete;
var brandAdd = function brandAdd(param, data) {
  return {
    type: _brand.actionTypes.ADD,
    payload: {
      param: param,
      data: data
    }
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.brandAdd = brandAdd;
var brandUpdate = function brandUpdate(data) {
  return {
    type: _brand.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * remove
 * @param payload
 * @returns api response
 * @description this function used to remove brand association.
 */
exports.brandUpdate = brandUpdate;
var brandRemove = function brandRemove(data) {
  return {
    type: _brand.actionTypes.REMOVE,
    payload: data
  };
};

/**
 * admin list
 * @param payload
 * @returns api response
 * @description this function used to get admin list.
 */
exports.brandRemove = brandRemove;
var brandAdminList = function brandAdminList(data) {
  return {
    type: _brand.actionTypes.ADMIN_LIST,
    payload: data
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get list of data.
 */
exports.brandAdminList = brandAdminList;
var brandContentList = function brandContentList(data) {
  return {
    type: _brand.actionTypes.CONTENT_LIST,
    payload: data
  };
};

/**
 * access
 * @param payload
 * @returns api response
 * @description this function used to get access of data.
 */
exports.brandContentList = brandContentList;
var brandAccessList = function brandAccessList(data) {
  return {
    type: _brand.actionTypes.ACCESS_LIST,
    payload: data
  };
};

/**
 * apply
 * @param payload
 * @returns api response
 * @description this function used to apply.
 */
exports.brandAccessList = brandAccessList;
var brandApply = function brandApply(payload) {
  return {
    type: _brand.actionTypes.APPLY,
    payload: payload
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to apply.
 */
exports.brandApply = brandApply;
var brandReset = function brandReset() {
  return {
    type: _brand.actionTypes.RESET
  };
};

/**
 * soft delete
 * @param payload
 * @returns api response
 * @description this function used to soft dalete data.
 */
exports.brandReset = brandReset;
var brandSoftDelete = function brandSoftDelete(data) {
  return {
    type: _brand.actionTypes.SOFT_DELETE,
    payload: data
  };
};

/**
 * soft delete restore
 * @param payload
 * @returns api response
 * @description this function used to soft dalete restore data.
 */
exports.brandSoftDelete = brandSoftDelete;
var brandSoftDeleteRestore = function brandSoftDeleteRestore(data) {
  return {
    type: _brand.actionTypes.SOFT_DELETE_RESTORE,
    payload: data
  };
};

/**
 * soft deleted list
 * @param payload
 * @returns api response
 * @description this function used to soft daleted list data.
 */
exports.brandSoftDeleteRestore = brandSoftDeleteRestore;
var brandSoftDeletedList = function brandSoftDeletedList(data) {
  return {
    type: _brand.actionTypes.SOFT_DELETED_LIST,
    payload: data
  };
};

/**
 * bulk soft deleted
 * @param payload
 * @returns api response
 * @description this function used to bulk soft dalete data.
 */
exports.brandSoftDeletedList = brandSoftDeletedList;
var brandBulkSoftDelete = function brandBulkSoftDelete(data) {
  return {
    type: _brand.actionTypes.BULK_SOFT_DELETE,
    payload: data
  };
};

/**
 * bulk hard deleted
 * @param payload
 * @returns api response
 * @description this function used to bulk hard dalete data.
 */
exports.brandBulkSoftDelete = brandBulkSoftDelete;
var brandBulkHardDelete = function brandBulkHardDelete(data) {
  return {
    type: _brand.actionTypes.BULK_HARD_DELETE,
    payload: data
  };
};

/**
 * bulk restore
 * @param payload
 * @returns api response
 * @description this function used to bulk restore data.
 */
exports.brandBulkHardDelete = brandBulkHardDelete;
var brandBulkRestore = function brandBulkRestore(data) {
  return {
    type: _brand.actionTypes.BULK_RESTORE,
    payload: data
  };
};

/**
 * bulk restore
 * @param payload
 * @returns api response
 * @description this function used to bulk restore data.
 */
exports.brandBulkRestore = brandBulkRestore;
var assetFolderViewTempDataSet = function assetFolderViewTempDataSet(data) {
  return {
    type: _brand.actionTypes.TEMP_DATA_SET,
    payload: data
  };
};
exports.assetFolderViewTempDataSet = assetFolderViewTempDataSet;